export default __webpack_public_path__ + "static/media/rfpl.a6da39b9.png";